import request from 'superagent';
import tree from '../state';
import config from '../config';

export function getContactUs() {
	return request.get(`${config.apiBase}/api/support/contactus`)
		.set('authorization', tree.get('token'))
		.then(res => JSON.parse(res.text));
}


// WEBPACK FOOTER //
// ./src/services/contactUsService.js